
import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import yogaHero from "../../images/yogaHero2.avif";

const styles = {
  parenBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding:"40px"
  },
  leftBox: {
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    flexDirection: "column",
    gap:3,
  },
  rightBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroTitle: {
    fontFamily: "poppins",
    fontWeight: "bold",
    lineHeight:1.5,
    opacity: 0.7,
  },
  heroSubtitle: {
    fontFamily: "poppins",
    fontWeight:600,
    opacity:0.7
  },
  button: {
    px: "10px",
    py:"5px",
    fontFamily: "poppins",
    fontSize: "14px",
    textTransform: "none",
    backgroundColor: "#141414FF",
    color: "#ffffff",
  },
};

const BlogHero = () => {
  const handleScroll = () => {
      const section = document.getElementById("yoga-cards-section");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      } 
    }
  return (
    <Container maxWidth="lg">
      <Box sx={{ ...styles.parenBox }}>
        {/* <Box sx={{ ...styles.leftBox }}>
          <Typography variant="h4" textAlign={"start"} sx={{ ...styles.heroTitle }}>
            Discover YourSelf <br /> Discover Yoga
          </Typography>
          <Typography variant="body1" textAlign="start" sx={{ ...styles.heroSubtitle }}>
            Find Your Balance, Embrace Your Peace – Begin Your Yoga Journey
            Today
          </Typography>
          <Button sx={{ ...styles.button }} variant="contained" onClick={handleScroll}>
            Start Now
          </Button>
        </Box> */}

        <Box sx={{ ...styles.rightBox }}>
          <Box component="img" src={yogaHero} sx={{width:"500px",heigh:"500px"}}/>
        </Box>
      </Box>
    </Container>
  );
};

export default BlogHero;
